import { _File } from "../files/types.js";
import { SharingRole, } from "./types.js";
import { shareWith, getShareLink, checkPermissions, getSharingInformation, getObjectSharingSettings, unshareObject, deleteLinkByKind, unshareLink, } from "./funcs.js";
_File.prototype.shareWith = function (loginNames, role, requireSignin, emailData) {
    if (role === void 0) { role = SharingRole.View; }
    if (requireSignin === void 0) { requireSignin = false; }
    return shareWith(this, loginNames, role, requireSignin, false, emailData);
};
_File.prototype.getShareLink = getShareLink;
_File.prototype.checkSharingPermissions = checkPermissions;
_File.prototype.getSharingInformation = getSharingInformation;
_File.prototype.getObjectSharingSettings = getObjectSharingSettings;
_File.prototype.unshare = unshareObject;
_File.prototype.deleteSharingLinkByKind = deleteLinkByKind;
_File.prototype.unshareLink = unshareLink;
//# sourceMappingURL=file.js.map